import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;
    window.gtag("config", "G-QKMLJQ2KZH", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
}

export default AnalyticsTracker;